import { useSeoMeta } from '@unhead/react';
import { SpaceGunGame } from '@/components/SpaceGunGame';

const Index = () => {
  useSeoMeta({
    title: 'Orbital Laser Defense',
    description: 'First-person space gun defense game. Blast incoming enemy missiles and alien ships from low earth orbit!',
  });

  return <SpaceGunGame />;
};

export default Index;
